<template>
    <div>
        <h2 class="titulo-bloco-dados-car">
            {{ $tc('certification.messages.car_data') }}
        </h2>
        <div class="container-conteudo">
            <div class="dados">
                <el-collapse
                    v-model="indicesCollapseConsolidadoTerritorio"
                    @change="addGeometriaTerritorio"
                    v-if="dadosTerritorio?.consolidadoTerritorio"
                >
                    <el-collapse-item :name="`collapse-consolidado-territorio`">
                        <template #title>
                            <h3 class="titulo-collapse">
                                {{
                                    $tc(
                                        'certification.messages.territory_consolidated'
                                    )
                                }}
                            </h3>
                        </template>
                        <div class="collapse-item-bloco-info">
                            <div class="info">
                                <label
                                    >{{
                                        $tc(
                                            'certification.messages.total_area_of_territory'
                                        )
                                    }}:</label
                                >
                                <span>{{
                                    formatNumber(
                                        dadosTerritorio?.consolidadoTerritorio
                                            ?.areaHa
                                    )
                                }}</span>
                            </div>
                            <div class="info">
                                <label
                                    >{{
                                        $tc(
                                            'certification.messages.total_planting_area'
                                        )
                                    }}:</label
                                >
                                <span>{{
                                    dadosTerritorio?.consolidadoTerritorio
                                        ?.areaPlantio
                                        ? formatNumber(
                                              dadosTerritorio
                                                  ?.consolidadoTerritorio
                                                  ?.areaPlantio
                                          )
                                        : $tc(
                                            'certification.words.does_not_have'
                                        )
                                }}</span>
                            </div>
                        </div>
                        <CollapseReservaLegal
                            :dados="
                                dadosTerritorio?.consolidadoTerritorio
                                    ?.reservaLegal || {}
                            "
                        />
                        <CollapseAreaPreservacaoPermanente
                            :dados="
                                dadosTerritorio?.consolidadoTerritorio?.app ||
                                {}
                            "
                        />
                        <CollapseListaDocumentos
                            :dados="
                                dadosTerritorio?.consolidadoTerritorio?.app ||
                                {}
                            "
                            :arquivos="arquivosCertificacao"
                            :dadosCertificacao="dadosCertificacao"
                            :dadosTerritorio="dadosTerritorio"
                        />
                    </el-collapse-item>
                </el-collapse>

                <el-collapse
                    v-model="indicesCollapseCar"
                    @change="addGeometriaCar(indicesCollapseCar)"
                    v-if="dadosTerritorio?.resultadosCars"
                >
                    <el-collapse-item
                        v-for="(car, index) in dadosTerritorio?.resultadosCars"
                        :key="index"
                        :name="`collapse-car-${index}`"
                    >
                        <template #title>
                            <h3 class="titulo-collapse">{{ car?.codigo }}</h3>
                        </template>
                        <div class="collapse-item-bloco-info">
                            <div class="info">
                                <label
                                    >{{
                                        $tc(
                                            'certification.messages.property_area'
                                        )
                                    }}:</label
                                >
                                <span>{{ formatNumber(car?.areaHa, 2) }}</span>
                            </div>
                            <div class="info">
                                <label
                                    >{{
                                        $tc(
                                            'certification.messages.registration_status'
                                        )
                                    }}:</label
                                >
                                <span>{{ car?.situacao || '-' }}</span>
                            </div>
                            <div class="info">
                                <label
                                    >{{
                                        $tc(
                                            'certification.messages.registration_condition'
                                        )
                                    }}:</label
                                >
                                <span>{{ car?.condicao || '-' }}</span>
                            </div>
                        </div>
                        <CollapseReservaLegal :dados="car.reservaLegal || {}" />
                        <CollapseAreaPreservacaoPermanente
                            :dados="car.app || {}"
                        />
                    </el-collapse-item>
                </el-collapse>
            </div>
            <div class="mapa">
                <mapa
                    ref="mapa"
                    :showStatesLayers="false"
                    :mapLayersConfigs="layersMap"
                    :mapConfig="mapConfig"
                    :height="'100%'"
                    :idMapa="'mapaDadosCarCertificacao'"
                    :atualizarMapa="true"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Mapa from '@/components/MapaLeaflet.vue';
import CollapseReservaLegal from './CollapseReservaLegal.vue';
import CollapseAreaPreservacaoPermanente from './CollapseAreaPreservacaoPermanente.vue';
import CollapseListaDocumentos from './CollapseListaDocumentos.vue';
import formatter from '@/utils/formatters';

const LAYER_CONSOLIDADO_TERRITORIO = 'layer-consolidado-territorio';
const LAYER_CAR = 'layer-car-';
const YELLOW = 'yellow';
const LIGHT_GREEN = '#00FF00';
const TIPO_GEOMETRIA = {
    TERRITORIO: 'TERRITORIO',
    AREA_PLANTADA: 'AREA_PLANTADA'
};

export default {
    name: 'DadosCar',
    components: {
        Mapa,
        CollapseReservaLegal,
        CollapseAreaPreservacaoPermanente,
        CollapseListaDocumentos
    },
    props: {
        dadosTerritorio: {
            type: Object,
            required: true
        },
        arquivosCertificacao: {
            type: Array,
            required: true
        },
        dadosCertificacao: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            layersMap: [],
            mapConfig: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true,
                    bufferControl: false
                }
            },
            indicesCollapseConsolidadoTerritorio: [
                'collapse-consolidado-territorio'
            ],
            indicesCollapseCar: [],
            copiaIndicesCollapseCar: []
        };
    },
    mounted() {
        this.abrirCollapseConsolidadoTerritorio();
    },
    methods: {
        formatNumber(number, decimalPlaces = 2) {
            if (!number) return '-';
            return formatter.formatNumber(number, decimalPlaces) + ' ha';
        },
        addGeometriaCar(arrayCollapseCarAbertos) {
            const collapsesAbertos = this.getIndicesCollapsesAbertos(
                arrayCollapseCarAbertos
            );

            if (this.copiaIndicesCollapseCar.length < collapsesAbertos.length) {
                this.addLayerCar(arrayCollapseCarAbertos);
            } else {
                this.removerLayerCar();
            }
        },
        getIndicesCollapsesAbertos(indices) {
            return indices.filter(i => i !== '');
        },
        addLayerCar(arrayCollapseCarAbertos) {
            const nomeUltimoCollapseAberto =
                arrayCollapseCarAbertos[arrayCollapseCarAbertos.length - 1];
            const index = this.getIndexCar(nomeUltimoCollapseAberto);

            if (index !== null) {
                this.addLayer(
                    this.dadosTerritorio.resultadosCars[index].geometria,
                    TIPO_GEOMETRIA.TERRITORIO,
                    LAYER_CAR + index
                );

                if (
                    this.dadosTerritorio.resultadosCars[index]
                        .geometriaAreaPlantada
                ) {
                    this.addLayer(
                        this.dadosTerritorio.resultadosCars[index]
                            .geometriaAreaPlantada,
                        TIPO_GEOMETRIA.AREA_PLANTADA,
                        LAYER_CAR + index
                    );
                }

                this.copiaIndicesCollapseCar = this.getIndicesCollapsesAbertos(
                    this.indicesCollapseCar
                );
            }
        },
        removerLayerCar() {
            const nomeCollapseRemovido = this.copiaIndicesCollapseCar.find(
                copia => !this.indicesCollapseCar.includes(copia)
            );
            const index = this.getIndexCar(nomeCollapseRemovido);

            if (index !== null) {
                this.removerLayer(LAYER_CAR + index);
                this.copiaIndicesCollapseCar = this.getIndicesCollapsesAbertos(
                    this.indicesCollapseCar
                );
            }
        },
        getIndexCar(nomeCollapse) {
            const indexUltimoSeparador = nomeCollapse.lastIndexOf('-');
            return Number(nomeCollapse.substring(indexUltimoSeparador + 1));
        },
        addLayer(geometria, tipoGeometria, nomeLayer) {
            if (geometria && nomeLayer) {
                const style = {
                    color:
                        tipoGeometria === TIPO_GEOMETRIA.TERRITORIO
                            ? LIGHT_GREEN
                            : YELLOW,
                    weight: 1,
                    fill: tipoGeometria === TIPO_GEOMETRIA.AREA_PLANTADA,
                    opacity: 100 / 200,
                    fillOpacity: 100 / 200
                };

                this.layersMap.push({
                    id: 'centroid' + Math.random(),
                    name: nomeLayer,
                    geoJson: geometria,
                    style
                });
            }
        },
        removerLayer(nomeLayer) {
            const updatedLayersMaps = this.layersMap.filter(
                l => l.name !== nomeLayer
            );
            this.layersMap = updatedLayersMaps;
        },
        addGeometriaTerritorio() {
            if (this.indicesCollapseConsolidadoTerritorio.length) {
                this.addLayerTerritorio();
            } else {
                this.removerLayer(LAYER_CONSOLIDADO_TERRITORIO);
            }
        },
        addLayerTerritorio() {
            if (this.dadosTerritorio?.consolidadoTerritorio?.geometria) {
                this.addLayer(
                    this.dadosTerritorio?.consolidadoTerritorio?.geometria,
                    TIPO_GEOMETRIA.TERRITORIO,
                    LAYER_CONSOLIDADO_TERRITORIO
                );
            }

            if (
                this.dadosTerritorio?.consolidadoTerritorio
                    ?.geometriaAreaPlantada
            ) {
                this.addLayer(
                    this.dadosTerritorio?.consolidadoTerritorio
                        ?.geometriaAreaPlantada,
                    TIPO_GEOMETRIA.AREA_PLANTADA,
                    LAYER_CONSOLIDADO_TERRITORIO
                );
            }
        },
        abrirCollapseConsolidadoTerritorio() {
            this.dadosTerritorio.consolidadoTerritorio
                ? this.addLayerTerritorio()
                : setTimeout(this.abrirCollapseConsolidadoTerritorio, 1500);
        }
    }
};
</script>

<style lang="scss">
.titulo-bloco-dados-car {
    font-weight: bold;
    margin: 1rem 0;
}

.container-conteudo {
    display: flex;
    gap: 20px;
    height: 500px;

    .dados,
    .mapa {
        flex: 1;
        border-radius: $default-border-radius;
    }

    .dados {
        .el-collapse-item__header {
            background: $white;

            .titulo-collapse {
                font-size: 16px;
                font-weight: bold;
                color: var(--primary-font-color);
            }
        }

        .collapse-item-bloco-info {
            display: flex;
            justify-content: flex-start;
            gap: 20px;
            background: $white;

            .info {
                display: flex;
                flex-direction: column;

                label {
                    color: var(--primary-font-color);
                }

                span {
                    font-weight: bold;
                    color: var(--primary);
                }
            }
        }
    }
}
</style>
